<template>
    <div class="order-detail-section mg20">
        <div>
            <el-row class="userInfo-group" v-if="order.finance && order.finance.contract_time">
                合同时间：{{order.finance.contract_time[0]}}~{{order.finance.contract_time[1]}}  销售额：{{order.finance.total_amount}}  <span v-if="order.type == 3">应续金额：{{order.finance.to_renew_amount}}</span>
            </el-row>
        </div>
    </div>
</template>

<script>
    export default {
        name: "order_contract_time",
        props:{
            order:{
                required: true
            },
        }
    }
</script>

<style scoped>

</style>


// WEBPACK FOOTER //
// src/views/order/partial/order_contract_time.vue